import { useMovementPatternVM } from "presentation/hook/MovementPattern/useMovementPatternVM";
import { useMovementPatternTracked } from "presentation/store/MovementPattern/MovementPatternProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import MovementPatternEditPanel from "./RightPanel/MovementPatternEditPanel";
import MovementPatternDtlTablePanel from "./Table/MovementPatternDtlTablePanel";
import MovementPatternTablePanel from "./Table/MovementPatternTablePanel";


const MovementPatternMaintenance: React.FC = () => {
    const [movementPatternState] = useMovementPatternTracked();
    const [isLoading, setIsLoading] = useState(true);
    const movementPatternVM = useMovementPatternVM();
    const { isShowEditPanel } = movementPatternState;


    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    movementPatternVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            movementPatternVM.searchAllMovementPatternList().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }).catch(error => {
            setIsLoading(false)
        });

    }, [movementPatternVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper`}>

            {!(isShowEditPanel) && <>
                <MovementPatternTablePanel /></>}
            {(isShowEditPanel) && <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={"40%"}
                rightSectionWidth={"60%"}
                leftChildren={<MovementPatternEditPanel movementPatternState={movementPatternState} />}
                rightChildren={<MovementPatternDtlTablePanel movementPatternState={movementPatternState} />}
            />}
        </div>
    </>
}

export default memo(MovementPatternMaintenance);